// extracted by mini-css-extract-plugin
export var chip = "_3e-0";
export var filterDropdown = "_3e-5";
export var filterItem = "_3e-6";
export var icon = "_3e-1";
export var removeButton = "_3e-3";
export var removeIcon = "_3e-4";
export var separator = "_3e-2";